import { render, staticRenderFns } from "./ChangeNameModal.vue?vue&type=template&id=e157b080"
import script from "./ChangeNameModal.vue?vue&type=script&lang=js"
export * from "./ChangeNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports